<div class="location-card">

    <!-- Display Mode -->
    <div id="displayMode" [style.display]="editToggle ? 'none' : 'block'">
        <div class="card-header">
            <div class="location-title">
                <h2 class="location-name" id="displayName">{{ yard.location }}</h2>
            </div>
        </div>

        <div class="status-section">
            <div class="status-label">Occupancy Status</div>
            <div class="occupancy-status"
                [ngClass]="{ 'status-occupied' : yard.status == 'OCCUPIED',
                 'status-available' : yard.status === 'EMPTY',
                'status-out-of-service' : yard.status === 'OUT_OF_SERVICE',
                'status-outgoing' : yard.status === 'OUTGOING',
                'status-incoming' : yard.status === 'INCOMING' }"
                id="displayStatus">
                <div class="status-indicator"></div>
                <span>{{ yard.status }}</span>
            </div>
        </div>

        <div class="objects-section">
            <div class="section-label">Trailer</div>
            <div class="objects-dropdown">
                <div class="dropdown-header" id="dropdownHeader">
                    <span id="objectCount">Status: {{ yard.trailer.status }}</span>
                    <span class="dropdown-arrow" id="dropdownArrow" (click)="toggleDrop()">▼</span>
                </div>
                <div class="dropdown-content" id="dropdownContent" [style.display]="dropToggle ? 'block' : 'none'">
                    <div class="object-item">
                        <div>
                            <div class="object-name">Trailer: {{ yard.trailer.trailer }}</div>
                        </div>
                        <div class="object-type">Carrier: {{ yard.trailer.carrier }}</div>
                    </div>
                    <div class="object-item">

                        <div class="object-name">PO: {{ yard.trailer.po }}</div>
                    </div>
                </div>
            </div>

            <div class="objects-dropdown">
                <div class="section-label">Actions</div>

                <button class="edit-toggle" id="editToggle" (click)="toggleEdit()">Edit</button>
            </div>
        </div>

    </div>

    <!-- Edit Mode -->
    <div id="editMode" [style.display]="editToggle ? 'block' : 'none'">
        <div class="card-header">
            <div class="location-title">
                <h2 class="location-name">Edit Location</h2>
            </div>
            <button class="edit-toggle editing" id="cancelEdit" (click)="toggleEdit()">Cancel</button>
        </div>

        <div class="form-group">
            <label class="form-label" for="editName">Location Name</label>
            <input type="text" class="form-input" name="editName" [(ngModel)]="yard.location">
        </div>

        <div class="form-group">
            <label class="form-label" for="editOccupancy">Occupancy Status</label>
            <select class="form-select" [(ngModel)]="yard.status" [disabled]="yard.status === 'INCOMING' || yard.status === 'OUTGOING'" (change)="saveChanges()">
                <option [ngValue]="'EMPTY'" *ngIf="yard.trailerId === null" >Empty</option>
                <option [ngValue]="'OCCUPIED'" *ngIf="yard.trailerId !== null">Occupied</option>
                <option [ngValue]="'OUT_OF_SERVICE'">Out of service</option>
            </select>
            <span>{{ yard?.status }}</span>
        </div>

        <div class="form-actions">
            <button type="button" class="btn btn-save" id="saveChanges" (click)="saveChanges()">Save
                Changes</button>
            <button type="button" class="btn btn-cancel" id="cancelChanges" (click)="toggleEdit()">Cancel</button>
        </div>


        <div class="form-group">
            <label class="form-label">Available trailers</label>
              <select class="form-select" *ngIf="yard.status === 'EMPTY'" [(ngModel)]="selectedTrailer"
                (change)="onSelectionChange()">
                <option [ngValue]="">Select a trailer...</option>
                <option [ngValue]="trailer" *ngFor="let trailer of availableTrailers">{{ trailer.trailer }}</option>
            </select>
            <label class="form-label">Trailer at Location</label>

          

            <div class="objects-edit" id="objectsEdit">
                <div class="object-edit-item">
                    <label class="form-label">Trailer</label>
                    <input type="text" class="form-input" name="trailer" [(ngModel)]="yard.trailer.trailer">
                    <label class="form-label">Carrier</label>
                    <input type="text" class="form-input" name="carrier" [(ngModel)]="yard.trailer.carrier">
                    <label class="form-label">Status</label>
                    <select name="status" class="form-input" [(ngModel)]="yard.trailer.status">
                        <option [value]="'EMPTY'">empty</option>
                        <option [value]="'LOADED'">loaded</option>
                        <option [value]="'OUT_OF_SERVICE'">out of service</option>
                    </select>

                    <label class="form-label">PO</label>
                    <input type="text" class="form-input" name="po" [(ngModel)]="yard.trailer.po">
                    <button type="button" class="btn btn-save" (click)="attachTrailer()" *ngIf="selectedTrailer && yard.status === 'EMPTY'">Attach Trailer</button>
                    <button type="button" class="btn btn-cancel" (click)="clearTrailer()">Clear Trailer</button>
                    <button type="button" class="btn btn-save" (click)="saveTrailer()" *ngIf="yard.trailer && yard.status !== 'EMPTY'">Save Trailer</button>
                    <button type="button" class="btn btn-cancel" (click)="removeItem()" *ngIf="yard.trailer && yard.status !== 'EMPTY'">Remove Trailer</button>
                </div>

            </div>
        </div>


    </div>
</div>